export const isMarketplacePartnerPortalRoute = pagePath => {
  const partnerPortalRoutesRegex = /\/manage\/vendors\/(\d+)\/*/;
  return partnerPortalRoutesRegex.test(pagePath);
};